import { CSSProperties, ReactNode } from "react";
import { Flex } from "flux";

import TitleBar from "./title-bar";
import PageHeader from "./page-header";

export interface PageProps {
  title: string;
  description?: string;
  subDescription?: string;
  descriptionLoading?: boolean;
  backLinkText?: string;
  backLinkPath?: string;
  testId?: string;
  children?: ReactNode;
  titleBarActions?: ReactNode;
  showSubDescriptionOnHeader?: boolean;
}

/** Horizontal padding for page content, as a CSS value.
 *
 * `Page` publishes the responsive figure as `--page-padding`, so anything rendered inside one tracks
 * it. The fallback covers routes that render their own `TitleBar` instead of a `Page` and so have no
 * such ancestor. */
export const PagePadding = "var(--page-padding, 48px)";

const Page = ({
  title,
  description,
  backLinkText,
  backLinkPath,
  testId,
  children,
  titleBarActions,
  subDescription,
  descriptionLoading,
  showSubDescriptionOnHeader
}: PageProps) => {
  return (
    <div className="relative" style={{ "--page-padding": "clamp(16px, 4cqw, 48px)" } as CSSProperties}>
      <TitleBar backLinkText={backLinkText} backLinkPath={backLinkPath}>
        {titleBarActions}
      </TitleBar>
      <Flex flexDirection="column" flexGrow={1} pt="32px" px="var(--page-padding)">
        <PageHeader
          title={title}
          description={description}
          subDescription={subDescription}
          descriptionLoading={descriptionLoading}
          testId={testId}
          showSubDescriptionOnHeader={showSubDescriptionOnHeader}
        />
        {children}
      </Flex>
    </div>
  );
};

export default Page;
